import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { makeStyles } from "components/providers/makeStyles";
import { Container, Typography } from "@mui/material";

import { useNavStyles } from "../commonStyles/navStyles";
import { useScheduleDays } from "./useScheduleDays";
import { useDivisionList } from "./useDivisionList";
import { DaySelector } from "./DaySelector";
import { HeatRow } from "./HeatRow";
import { Break } from "./Break";
import { T } from "../../util/t";
import { Select } from "../forms/fields/Select";

const useStyles = makeStyles(theme => ({
    message: {
        marginBottom: theme.spacing(2)
    },
    select: {
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up("md")]: {
            width: "60%"
        }
    },
    container: {
        paddingBottom: theme.spacing(5),
        [theme.breakpoints.down("lg")]: {
            maxWidth: "100vw"
        }
    }
}));
export const EventSchedule = ({ event }) => {
    const { fullSchedule } = event;
    const { days, sortedDays, selectedDay: selectedDayFromDayStatuses } = useScheduleDays(fullSchedule);
    const [selectedDay, setSelectedDay] = useState(selectedDayFromDayStatuses);
    const displayedDay = selectedDay >= sortedDays.length ? sortedDays.length - 1 : selectedDay;
    const displayedSchedule = days[sortedDays[displayedDay]];
    const [displayedPodium, setDisplayedPodium] = useState(displayedSchedule.findIndex(podium => podium.length));
    const showPodiumSelector = useMemo(
        () => displayedSchedule.length > 1 && displayedSchedule.every(podiums => podiums.length),
        [displayedSchedule]
    );
    useEffect(() => {
        if (!showPodiumSelector) setDisplayedPodium(displayedSchedule.findIndex(podium => podium.length));
    }, [showPodiumSelector]);

    const divisions = useDivisionList(event.eventDivisions);
    const navClasses = useNavStyles();
    const classes = useStyles();

    return (
        <Container className={classes.container}>
            <nav className={navClasses.nav}>
                {sortedDays.map((day, index) =>
                    <DaySelector
                        key={day}
                        day={day}
                        selected={displayedDay === index}
                        selectDay={() => setSelectedDay(index)}/>)}
            </nav>

            {showPodiumSelector &&
                <div className={classes.select}>
                    <Select
                        field={{ options: fullSchedule.podiums.map((podium, i) => ({ label: podium.name, value: i })) }}
                        input={{ value: displayedPodium, onChange: e => setDisplayedPodium(e.target.value) }}
                    />
                </div>
            }

            <Typography variant="caption" component="p" color="textSecondary" className={classes.message}>
                <T timezone={dayjs().format("Z")}>timezone_message</T>
            </Typography>

            {displayedSchedule[displayedPodium].map((heat, i) =>
                heat ?
                    <HeatRow key={heat.id} heat={heat} divisionIndicator={divisions[heat.eventDivision.division.id]}/> :
                    (i !== displayedSchedule[displayedPodium].length - 1) && <Break key={i}/>
            )}
        </Container>
    );
};
